import { INofshonPayment } from './../model/nofshon-payment';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormArray, Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ITashlum } from './../../nofesh/model/tashlum';
import { MenuHandler } from 'app/shared/menu-handler';
import { NofshonimService } from 'app/nofshonim-chul/nofshonim.service';
import { identifierModuleUrl } from '@angular/compiler';
import { EILSEQ } from 'constants';
import { retry } from 'rxjs/operators/retry';
import { Console } from '@angular/core/src/console';
import { ModalComponent } from '../../shared/modal/modal.component';
import { Observable, Subscription } from 'rxjs';
import { IfObservable } from 'rxjs/observable/IfObservable';
import { IAddTashlum } from '../model/IAddTashlum';
import { ENofeshType } from '../../shared/enums/enofesh-type.enum';
import { INofesh } from '../../nofesh/model/nofesh';
import { INofshonNirshamim } from '../model/nofshon-nirshamim';
import { INofshonNirsham } from '../model/nofshon-nirsham';
import { INofeshSelected } from 'app/shared/interfaces/Inofesh-selected.interface';
import { NofshonReservationTimerService } from 'app/shared/timer/nofshon-reservation-timer.service';
import { UserMessagesService } from 'app/shared/user-messages/user-messages.service';
import { ConfirmDialogComponent } from 'app/shared/dialog/confirm-dialog/confirm-dialog.component';
import { ConfirmService } from 'app/shared/dialog/confirm.service';
import { MatDialog } from '@angular/material';


declare var $: any;

@Component({
    moduleId: module.id,
    templateUrl: './pirtey-tashlum.component.html',
})
export class PirteyTashlumComponent implements OnInit, OnDestroy {

    constructor(
        private _activateRoute: ActivatedRoute,
        private _router: Router,
        private fb: FormBuilder,
        private _nofshonimService: NofshonimService,
        private _nofshonReservationTimerService: NofshonReservationTimerService,
        private _userMessagesService: UserMessagesService,
        private _confirmDialogService: ConfirmService,
        private _confirmDialog: MatDialog
    ) {
        this.createForm();
    }


    nofeshId: number = this._activateRoute.snapshot.params.id;
    form: FormGroup;
    nofshonPayment: INofshonPayment;
    dolar_rate: number;
    // ms_chadarim: number = 1;
    // nofesh_price: number = 2496;
    // isLoading: boolean = true;
    // circelPrograssPercent: number = 0;
    sumTashlumim: number = 0;
    miss_sum: number = 0;
    isvalidform: boolean = true;
    errorMessage: string;
    is_submited: boolean;
    nofesh_type: number;
    nofesh_title: string;
    shem_prati: string;
    shem_mishpacha: string;
    amitimNirshamim: number = 1;
    userSelectedNofesh: INofeshSelected;
    private _timeoutSubscription: Subscription;
    nofeshTypes: typeof ENofeshType = ENofeshType;


    ngOnInit() {
        window.scroll(0, 0);

        let nofashim: INofesh[] = JSON.parse(sessionStorage.getItem("nofashim"));
        if (nofashim == null) {
            this.navigateToNofeshPage();
            return;
        }
        this.nofesh_type = nofashim.filter(r => r.id_nofesh == this.nofeshId)[0].nofeshType;
        this.nofesh_title = nofashim.filter(r => r.id_nofesh == this.nofeshId)[0].nofeshTitle;

        this.userSelectedNofesh = JSON.parse(sessionStorage.getItem("userSelectedNofesh"));
        if (this.userSelectedNofesh) {
            this.shem_prati = this.userSelectedNofesh.shem_prati;
            this.shem_mishpacha = this.userSelectedNofesh.shem_mishpacha;

            if (!this.userSelectedNofesh.isReservationCompleted && this._nofshonimService.shouldDisplayTimer(this.userSelectedNofesh)) {
                const reservationExpiration = this._nofshonReservationTimerService.getReservationExpiration(this.userSelectedNofesh.moed_rishum);
                const isExpired = this._nofshonReservationTimerService.checkIfTimerTimedOut(reservationExpiration);
                if (isExpired) {
                    console.log("Pirtey tashlum - navigating to home on timeout");
                    this.navigateToNofeshPage();
                    return;
                }
                else {
                    this._nofshonReservationTimerService.resumeTimer(reservationExpiration);
                    this._timeoutSubscription = this._nofshonReservationTimerService.timerTimeout$.subscribe((timeout: boolean) => {
                        console.log("Pirtey tashlum - timer notified. Is timeout?", timeout);
                        if (timeout) {
                            console.log("Pirtey tashlum - navigating to home on resumed timeout");
                            this.navigateToNofeshPage();
                        }
                    });
                }
            }
        }


        //get nofshon payment.
        this._nofshonimService.getNofshonPayment(this.nofeshId).subscribe(res => {
            this.nofshonPayment = res.nofshonPayment;
            this.dolar_rate = res.nofshonPayment.dolar_rate;

            if (res.nofshonTashlumim.length > 0) {
                res.nofshonTashlumim.forEach(t => this.addTashlum(t));
            }
            else {
                this.addTashlum(this.CreateTashlum(res.nofshonPayment.ms_zehut_mazmin, res.nofshonPayment.mechir_le_nofesh));
            }

        });

        const nirshamim: INofshonNirshamim = JSON.parse(sessionStorage["nofshon-nirshamim"]);
        if (nirshamim && nirshamim.nirshamim && nirshamim.nirshamim.length > 1) {
            this.amitimNirshamim = nirshamim.nirshamim.reduce((amitim: number, nirsham: INofshonNirsham, index: number) => {
                return nirsham.is_amit === 1 ? amitim + 1 : 0;
            }, 0);
        }


        MenuHandler.menuHandler($(".wiz_group"), $("#li_pirtey_tashlum"));


    }

    navigateToNofeshPage(): void {
        this._router.navigate(["/nofesh"]);
    }

    createForm() {


        this.form = this.fb.group({

            nofesh_id: this.nofeshId,
            ms_zehut_mazmin: 0,
            tashlumim: this.fb.array([
            ])
        })
    }

    get tashlumim() { return <FormArray>this.form.controls['tashlumim']; }

    InitTashlum(tashlum: ITashlum) {
        let fg: FormGroup;
        if (tashlum) {
            fg = this.fb.group({
                ms_zehut_meshalem: [tashlum.ms_zehut_meshalem, Validators.required],
                ofen_tashlum: [tashlum.ofen_tashlum.toString()],
                ms_tashlumim: [tashlum.ms_tashlumim, Validators.required],
                schum_tashlum: [tashlum.schum_tashlum, Validators.required],
                teur_tashlum: [tashlum.teur_tashlum],
                tashlum_id: [tashlum.tashlum_id]

            })
        }
        else {
            fg = this.fb.group({
                ms_zehut_meshalem: ["", Validators.required],
                ofen_tashlum: [1],
                ms_tashlumim: [1, Validators.required],
                schum_tashlum: [0, Validators.required],
                teur_tashlum: [""],
            })
        }
        return fg;
    }

    addTashlum(item: ITashlum) {
        const control = <FormArray>this.form.controls['tashlumim'];
        control.push(this.InitTashlum(item));
    }

    removeTashlum(index: number) {
        const control = <FormArray>this.form.controls['tashlumim'];
        control.removeAt(index);
    }

    CreateTashlum(ms_zehut?: number, schum_tashlum?: number) {
        // ;
        return {
            ms_zehut_meshalem: (ms_zehut) ? ms_zehut : 0,
            ofen_tashlum: 1,
            ms_tashlumim: 1,
            schum_tashlum: (schum_tashlum) ? schum_tashlum : 0,
            teur_tashlum: "",
            tashlum_id: -1
        }
    }

    ValidateSum() {
        let tashlumim = (<FormArray>this.form.controls['tashlumim']).controls;
        let sum: number = 0;

        for (var tashlum of tashlumim) {
            sum += +(<FormGroup>tashlum).controls['schum_tashlum'].value;
        }



        if (sum == this.nofshonPayment.mechir_le_nofesh) {
            return true;
        }
        else {
            if (sum > this.nofshonPayment.mechir_le_nofesh)
                this.miss_sum = sum - this.nofshonPayment.mechir_le_nofesh;
            else
                this.miss_sum = this.nofshonPayment.mechir_le_nofesh - sum;

            return false;
        }

    }

    save(event, { value, valid }: { value: any, valid: boolean }): void {
        // value is of form item type. See creteForm() for object properties.
        event.preventDefault();
        this.is_submited = true;
        this.errorMessage = null;

        if (!valid) {
            this.isvalidform = false;
            this.errorMessage = 'נא למלא את כל שדות החובה באופן תקין';
            this.is_submited = false;
            return;
        }

        if (!this.ValidateSum()) {
            this.isvalidform = false;
            this.errorMessage = 'הסכומים שהוזנו אינם תואמים לסכום הנופש - ' + 'קיים פער של ' + '₪' + this.miss_sum;
            this.is_submited = false;
            return;
        }

        this._nofshonimService.saveNofshonTashlumim(value)
            .subscribe(res => {
                if (res.status) {
                    sessionStorage.setItem('nofshon-tashlumim', JSON.stringify(value));
                }

                /*
                Due to Sharon's request and thinking that the uploads takes time and might make the servers to be busy, 
                we decided to take off the uploads during the standard flow and create a button after the flow finishes.
                */

                // if (this.nofesh_type == ENofeshType.NofeshPnim || this.nofesh_type == ENofeshType.MeurganimPnim)
                // {
                //     this._router.navigate(['nofshonim-chul', 'end-rishum']);
                // }
                // else if(this.nofesh_type == ENofeshType.NofeshChul)
                // {
                //     this._router.navigate(['nofshonim-chul/uploads/'+this.nofeshId]);
                // }
                // else if(this.nofesh_type == ENofeshType.MishpachotChul)
                // {
                //     this._router.navigate(['mishpachot-chul/uploads/'+this.nofeshId]);
                // }

                this._router.navigate(['nofshonim-chul', 'end-rishum']);


            },
                error => {
                    if (error.status === "401") {
                        localStorage.removeItem("token");
                        location.reload();
                    }

                    this.isvalidform = false;
                    this.errorMessage = "אירעה שגיאה";
                    this.is_submited = false;
                });
    }

    cancelReservation(): void {
        if (this._nofshonimService.shouldDisplayTimer(this.userSelectedNofesh) && this.userSelectedNofesh.id_reservation > 0 && !this.userSelectedNofesh.isReservationCompleted && this._nofshonReservationTimerService.checkIfInMinimalPeriodToStopTimer(this.userSelectedNofesh.moed_rishum)) {
            this._nofshonReservationTimerService.stopTimer();
            this._nofshonReservationTimerService.hideTimer();
            console.log("Pirtey tashlum - cancel reservation by user on minimal timer time. Timer is stopped");
        }

        this._nofshonimService.cancelNofshonReservation(this.nofeshId).subscribe(() => {
            //this._nofshonimService.cancelNofshonReservation().subscribe(() => {
            this._nofshonimService.clearSessionOnCancelReservation(this.nofeshId);
            if (this._nofshonimService.shouldDisplayTimer(this.userSelectedNofesh) && this._nofshonReservationTimerService.isTimerShown && this.userSelectedNofesh.id_reservation > 0 && !this.userSelectedNofesh.isReservationCompleted) {
                this._nofshonReservationTimerService.stopTimer();
                this._nofshonReservationTimerService.hideTimer();
                console.log("Pirtey tashlum - cancel reservation by user. Timer is stopped");
            }

            const message = "ההזמנה בוטלה בהצלחה";
            this._userMessagesService.showSnackBarSuccessMessage(message, null, this._userMessagesService.clearAll.bind(this._userMessagesService));
            this._userMessagesService.setSuccessMessage(message);
            this.navigateToNofeshPage();
        });
    }

    showConfirmCancelDialog() {
        let data;
        if (this.userSelectedNofesh.isReservationCompleted) {
            data = {
                title: "ביטול הזמנה",
                content: [
                    "האם לבטל את ההזמנה?",
                    "",
                    "עלות ביטול הזמנה בעמותה - 80 ₪ לנוסע.",
                    "לא ייגבה תשלום על ביטול נופש בהמתנה."
                ],
                confirmButtonText: "כן, אני רוצה לבטל",
                declineButtonText: "סגור"
            }
        }
        else {
            data = {
                title: "ביטול הזמנה",
                content: ["האם לבטל את ההזמנה?"]
            }
        }

        const dialogRef = this._confirmDialog.open(ConfirmDialogComponent, {
            width: "600px",
            data,
            hasBackdrop: true,
            disableClose: true,
            restoreFocus: true,
            closeOnNavigation: true
        });

        const dialogSubscription = this._confirmDialogService.confirm$.subscribe(() => {
            dialogRef.close();
            dialogSubscription.unsubscribe();
            this.cancelReservation();
        });

    }

    ngOnDestroy() {
        if (this.userSelectedNofesh && this._nofshonimService.shouldDisplayTimer(this.userSelectedNofesh)) {
            if (this._timeoutSubscription) {
                this._timeoutSubscription.unsubscribe();
            }
        }
    }
}

